import type { AxisBottomTickProps } from "../components/shared/types";
import { TickVisibilityController } from "../support/TickVisibilityController";
import { getTickCount } from "../support/helpers";

export default function useTickVisibilityController({
    data = []
}: Pick<AxisBottomTickProps, 'data'>) {
    return TickVisibilityController.boot(getTickCount(data));
};
